import { Tooltip, useTheme } from '@mui/material';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import React from 'react';
import { isEmpty } from 'lodash';
import styles from '../styles/LessonComponentList.module.css';
import { useLessonEditContext } from '../models/LessonEditContext';

interface AddComponentContainerProps {
  invalidMove: boolean;
  componentIndex: number;
  onCreate: () => void;
  onDuplicate: () => void;
  onMultipleMove: () => void;
}

export const AddComponentContainer = (props: AddComponentContainerProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const fontFamily = muiTheme.typography.fontFamily;
  const { selectedComponentKeys } = useLessonEditContext();

  const handleCreate = () => {
    if (isEmpty(selectedComponentKeys)) {
      props.onCreate();
    }
  };

  const toolTipText = `${selectedComponentKeys.length} selected component${
    selectedComponentKeys.length > 1 ? 's' : ''
  }`;

  return (
    <Grid
      container
      className={`${
        props.componentIndex === 0 ? styles.addComponentContainerMargin : ''
      } ${styles.addComponentContainer}`}
      onClick={handleCreate}
    >
      <Grid
        container
        justifyContent="center"
        className={styles.multiSelectComponentsContainer}
        style={{ fontFamily }}
      >
        <Grid onClick={props.onCreate}>
          <Tooltip
            title={
              <div>
                <span>Add a component</span>
              </div>
            }
            placement="bottom"
            arrow
          >
            <IconButton
              size="small"
              color="primary"
              className={
                selectedComponentKeys.length > 0
                  ? styles.multiSelectComponentEditButton
                  : styles.addComponentButton
              }
            >
              <AddCircleIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        {selectedComponentKeys.length > 0 && (
          <Grid onClick={props.onDuplicate}>
            <Tooltip
              title={
                <div>
                  <span>Copy {toolTipText}</span>
                </div>
              }
              placement="bottom"
              arrow
            >
              <IconButton
                size="small"
                color="primary"
                className={styles.multiSelectComponentEditButton}
              >
                <FileCopyIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        {selectedComponentKeys.length > 0 && (
          <Grid onClick={props.invalidMove ? () => {} : props.onMultipleMove}>
            <Tooltip
              title={
                <div>
                  <span>Move {toolTipText}</span>
                </div>
              }
              placement="bottom"
              arrow
              disableHoverListener={props.invalidMove}
            >
              <span>
                <IconButton
                  size="small"
                  color="primary"
                  disabled={props.invalidMove}
                  className={styles.multiSelectComponentEditButton}
                >
                  <OpenWithIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        )}
      </Grid>
      <Grid
        style={{
          backgroundColor: `${primaryColor}`
        }}
        className={styles.addComponentBar}
      ></Grid>
    </Grid>
  );
};
